import { Row } from 'components/grid'
import MobileNavigationMenu from 'components/Layout/Header/Navigation/MobileNavigationMenu'
import NavigationMenu from 'components/Layout/Header/Navigation/NavigationMenu'
import { Link } from 'gatsby'
import React from 'react'

const Navigation = () => {
	return (
		<>
			<Row overflow={false} className={`relative mx-auto w-full py-6 lg:max-w-screen-lg xl:max-w-screen-xl`}>
				<div className="flex w-full justify-between px-4 md:items-center xl:items-start">
					<div className="relative z-40 -mb-10 max-w-max bg-ar-100 p-2">
						<Link to="/">
							<img
								src="/images/logos/arc-logo-white-alt-tagline.svg"
								alt="red logo for american reading company"
								height={64}
								width={143.5}
								className="h-14 md:h-16"
							/>
						</Link>
					</div>
					<div className="hidden flex-col items-center xl:flex xl:flex-row">
						{navigationMenus.map((menu) => {
							return <NavigationMenu key={menu.name} menu={menu} />
						})}
					</div>
					<MobileNavigationMenu navItems={navigationMenus} />
				</div>
			</Row>
		</>
	)
}

export default Navigation

export interface INavigationMenu {
	name: string
	menuItems?: { name: string; href?: string; isNew?: boolean; externalLink?: string }[]
	colors: { border: string; hoverBg: string; groupHoverText: string; focusRing: string; mobileBg: string; mobileBgLight: string; mobileText: string }
	href?: string
}

const navigationMenus: INavigationMenu[] = [
	{
		name: 'High-Quality Curriculum',
		colors: {
			border: 'border-blue-600',
			hoverBg: 'hover:bg-blue-100',
			groupHoverText: 'group-hover:text-blue-700',
			focusRing: 'focus-visible:ring-blue-500',
			mobileBg: 'bg-blue-500',
			mobileBgLight: 'bg-blue-100',
			mobileText: 'text-blue-900'
		},
		menuItems: [
			{
				name: 'Science of Reading',
				href: '/science-of-learning/science-of-reading'
			},
			{
				name: 'ARC Core (K-5)',
				href: '/arc-core'
			},
			{
				name: 'ARC Core Fusion (6-8)',
				href: '/arc-core-fusion'
			},
			{
				name: 'ARC Core (9-12)',
				href: '/arc-core-high-school'
			},
			{
				name: 'Digital Literacy Solutions',
				href: '/digital-solutions'
			},
			{
				name: 'Professional Learning',
				href: '/professional-learning'
			},
			{
				name: 'Assessment',
				href: '/formative-assessment'
			},
			{
				name: 'TEKS',
				href: '/teks'
			}
		]
	},
	{
		name: 'Supplemental Solutions',
		colors: {
			border: 'border-purple-600',
			hoverBg: 'hover:bg-purple-100',
			groupHoverText: 'group-hover:text-purple-700',
			focusRing: 'focus-visible:ring-purple-500',
			mobileBg: 'bg-purple-500',
			mobileBgLight: 'bg-purple-100',
			mobileText: 'text-purple-900'
		},
		menuItems: [
			{
				name: 'Home & School Literacy Culture',
				href: '/100-book-challenge'
			},
			{
				name: 'Intervention',
				href: '/intervention'
			},
			{
				name: 'Summer Solutions',
				href: '/summer'
			},
			{
				name: 'Thematic Units & Text Sets',
				href: '/themes'
			},
			{
				name: 'Libraries',
				href: '/libraries'
			},
			{
				name: 'TEKS',
				href: '/teks'
			}
		]
	},
	{
		name: 'Leadership',
		colors: {
			border: 'border-pink-600',
			hoverBg: 'hover:bg-pink-100',
			groupHoverText: 'group-hover:text-pink-700',
			focusRing: 'focus-visible:ring-pink-500',
			mobileBg: 'bg-pink-500',
			mobileBgLight: 'bg-pink-100',
			mobileText: 'text-pink-900'
		},
		menuItems: [
			{
				name: 'Literacy Operating System',
				href: '/literacy-operating-system'
			},
			{
				name: 'Leadership Learning Series',
				href: '/professional-learning/#leadership-learning-series'
			}
			// {
			// 	name: 'From Pedagogy to Practice',
			// 	href: '/professional-learning'
			// },
			// {
			// 	name: 'ARC University',
			// 	href: '/professional-learning/#arc-university'
			// }
		]
	},
	{
		name: 'About Us',
		colors: {
			border: 'border-red-600',
			hoverBg: 'hover:bg-red-100',
			groupHoverText: 'group-hover:text-red-700',
			focusRing: 'focus-visible:ring-red-500',
			mobileBg: 'bg-red-500',
			mobileBgLight: 'bg-red-100',
			mobileText: 'text-red-900'
		},
		menuItems: [
			// {
			// 	name: 'Our Approach',
			// 	href: '/'
			// },
			// {
			// 	name: 'Our Team',
			// 	href: '/our-team'
			// },
			{
				name: 'Get to Know ARC',
				href: '/about-us'
			},
			{
				name: 'Academic Advisory Council',
				href: '/academic-advisory-council'
			},
			{
				name: 'Partnerships',
				href: '/partnerships'
			},
			{
				name: 'ARC Press',
				href: '/arc-press'
			},
			{
				name: 'ARC Loves',
				href: '/arc-loves'
			},
			{
				name: 'Student-Authored Books',
				href: '/student-books'
			}
		]
	},
	{
		name: 'Impact',
		href: '/state-reviews',
		colors: {
			border: 'border-orange-600',
			hoverBg: 'hover:bg-orange-100',
			groupHoverText: 'group-hover:text-orange-700',
			focusRing: 'focus-visible:ring-orange-500',
			mobileBg: 'bg-orange-500',
			mobileBgLight: 'bg-orange-100',
			mobileText: 'text-orange-900'
		},
		menuItems: [
			{
				name: 'District Results',
				href: '/district-results'
			},
			{
				name: 'Independent Reviews',
				href: '/state-reviews#results'
			},
			{
				name: 'State Reviews',
				href: '/state-reviews'
			}
		]
	},
	{
		name: 'Contact',
		href: '/connect',
		colors: {
			border: 'border-yellow-600',
			hoverBg: 'hover:bg-yellow-100',
			groupHoverText: 'group-hover:text-yellow-700',
			focusRing: 'focus-visible:ring-yellow-500',
			mobileBg: 'bg-yellow-500',
			mobileBgLight: 'bg-yellow-100',
			mobileText: 'text-yellow-900'
		}
	}
]
